export default  {
	id: '',
	name: '',
	properties: '',
	legal_name: '',
	marketing_name: '',
	code: '',
	notes: '',
	has_feed: '',
	color: '',
	finance_name: '',
	finance_address: '',
	finance_city: '',
	finance_state: '',
	finance_zip: '',
	btr: '',
	marketing_description: '',
	type: "",
	floorplan_collections: [],
	land_bank: {}
}